var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResourcesApiDocs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.99927 11.6667L8.3326 10L9.99927 8.33334L11.6659 10L9.99927 11.6667ZM8.22844 6.915L6.48177 5.16834L8.93198 2.71792C9.08267 2.56737 9.25149 2.45577 9.43844 2.38313C9.62538 2.31049 9.81233 2.27417 9.99927 2.27417C10.1862 2.27417 10.3732 2.31049 10.5601 2.38313C10.747 2.45577 10.9159 2.56737 11.0666 2.71792L13.5168 5.16834L11.7701 6.915L9.99927 5.14417L8.22844 6.915ZM5.1676 13.5175L2.71719 11.0673C2.56663 10.9166 2.45503 10.7478 2.3824 10.5608C2.30976 10.3739 2.27344 10.1869 2.27344 10C2.27344 9.81306 2.30976 9.62611 2.3824 9.43917C2.45503 9.25223 2.56663 9.08341 2.71719 8.93271L5.1676 6.4825L6.91427 8.22917L5.14344 10L6.91427 11.7708L5.1676 13.5175ZM14.8309 13.5175L13.0843 11.7708L14.8551 10L13.0843 8.22917L14.8309 6.4825L17.2814 8.93271C17.4319 9.08341 17.5435 9.25223 17.6161 9.43917C17.6888 9.62611 17.7251 9.81306 17.7251 10C17.7251 10.1869 17.6888 10.3739 17.6161 10.5608C17.5435 10.7478 17.4319 10.9166 17.2814 11.0673L14.8309 13.5175ZM8.93198 17.2821L6.48177 14.8317L8.22844 13.085L9.99927 14.8558L11.7701 13.085L13.5168 14.8317L11.0666 17.2821C10.9159 17.4326 10.747 17.5442 10.5601 17.6169C10.3732 17.6895 10.1862 17.7258 9.99927 17.7258C9.81233 17.7258 9.62538 17.6895 9.43844 17.6169C9.25149 17.5442 9.08267 17.4326 8.93198 17.2821Z",
    fill: "#A1A1A1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourcesApiDocs);
export default __webpack_public_path__ + "static/media/resources-api-docs.0e32e6f054f9af15c9d08d7cd60de66f.svg";
export { ForwardRef as ReactComponent };